import { Section } from '@/components/common/Section';
import { cn } from '@/lib/cn';
import type { HTMLAttributes } from 'react';

interface DashboardTwoColumnSectionProps extends HTMLAttributes<HTMLDivElement> {
  containerClassName?: string;
}

export const DashboardTwoColumnSection = ({
  containerClassName,
  className,
  ...props
}: DashboardTwoColumnSectionProps) => {
  return (
    <Section
      containerClassName={cn('lg:py-15', containerClassName)}
      className={cn(
        'flex flex-col gap-15.5 lg:flex-row lg:items-start lg:justify-between',
        className,
      )}
      {...props}
    />
  );
};
